import classNames from 'classnames'
import format from 'date-fns/format'
//import isDate from 'date-fns/is_date'
import PropTypes from 'prop-types'
import React from 'react'

import getUnixDateTime from 'utils/get-unix-date-time'

import styles from './DateTime.module.scss'

export default function DateTime({ className: propsClassName, value }: props) {
  const className = classNames('DateTime', styles.this, propsClassName)

  if (!value) {
    return (
      <span className={classNames(className, styles['this---empty'])} />
    )
  }

  const dateTime = getUnixDateTime(value)

  return (
    <time dateTime={format(dateTime)} className={className}>
      {format(dateTime, 'D MMMM YYYY')}
    </time>
  )
}

DateTime.propTypes = {
  className: PropTypes.string,
  value: PropTypes.number.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/DateTime/DateTime.js